import React, { useState, useEffect, useCallback } from 'react';

const token = () => localStorage.getItem('token');
const api = (path, method = 'GET', body) =>
  fetch(`/${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
    body: body ? JSON.stringify(body) : undefined,
  }).then(r => r.json());

function fmtNum(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('pt-BR');
}

function StatusBadge({ status, seguidores }) {
  const map = {
    qualificado:     { label: `✅ ${fmtNum(seguidores)} seguidores`, bg: '#f0fdf4', cor: '#16a34a', border: '#bbf7d0' },
    descartado:      { label: `❌ ${fmtNum(seguidores)} seguidores`, bg: '#fef2f2', cor: '#dc2626', border: '#fecaca' },
    sem_seguidores:  { label: 'Perfil sem dados',  bg: '#fffbeb', cor: '#d97706', border: '#fde68a' },
    nao_encontrado:  { label: 'Não encontrado',    bg: '#f3f4f6', cor: '#6b7280', border: '#e5e7eb' },
    erro:            { label: 'Erro na busca',     bg: '#fef2f2', cor: '#dc2626', border: '#fecaca' },
    pendente:        { label: 'Aguardando...',     bg: '#f0f9ff', cor: '#0369a1', border: '#bae6fd' },
  };
  const s = map[status] || map.pendente;
  return (
    <span style={{ background: s.bg, color: s.cor, border: `1px solid ${s.border}`, borderRadius: 10, padding: '2px 10px', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' }}>
      {s.label}
    </span>
  );
}

export default function Prospeccao() {
  const [status, setStatus] = useState({ rodando: false, total: 0, processados: 0, encontrados: 0 });
  const [resultados, setResultados] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [adicionando, setAdicionando] = useState({});
  const [filtro, setFiltro] = useState('todos');

  const carregarResultados = useCallback(async () => {
    const [st, res] = await Promise.all([api('prospeccao/status'), api('prospeccao/resultados')]);
    setStatus(st);
    if (Array.isArray(res)) setResultados(res);
    setCarregando(false);
  }, []);

  useEffect(() => {
    carregarResultados();
  }, [carregarResultados]);

  useEffect(() => {
    if (!status.rodando) return;
    const t = setInterval(carregarResultados, 4000);
    return () => clearInterval(t);
  }, [status.rodando, carregarResultados]);

  async function iniciar() {
    await api('prospeccao/iniciar', 'POST');
    setTimeout(carregarResultados, 1000);
  }

  async function parar() {
    await api('prospeccao/parar', 'POST');
    carregarResultados();
  }

  async function limpar() {
    if (!window.confirm('Limpar todos os resultados?')) return;
    await api('prospeccao/limpar', 'DELETE');
    setResultados([]);
    setStatus({ rodando: false, total: 0, processados: 0, encontrados: 0 });
  }

  async function adicionarCRM(id) {
    setAdicionando(a => ({ ...a, [id]: true }));
    const resp = await api(`prospeccao/${id}/adicionar-crm`, 'POST');
    if (resp.ok) {
      setResultados(prev => prev.map(r => r._id === id ? { ...r, adicionado_crm: true } : r));
    } else {
      alert('Erro ao adicionar: ' + (resp.erro || 'tente novamente'));
    }
    setAdicionando(a => ({ ...a, [id]: false }));
  }

  const filtrados = resultados.filter(r => {
    if (filtro === 'qualificados') return r.instagram_status === 'qualificado';
    if (filtro === 'nao_encontrados') return r.instagram_status === 'nao_encontrado';
    if (filtro === 'pendentes') return !r.instagram_status || r.instagram_status === 'pendente';
    return true;
  });

  const qtdQualif = resultados.filter(r => r.instagram_status === 'qualificado').length;
  const progresso = status.total > 0 ? Math.round((status.processados / status.total) * 100) : 0;

  const inp = { padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, height: 26, boxSizing: 'border-box' };

  return (
    <div style={{ maxWidth: 1100 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>Prospecção Automática</h1>
          <p style={{ color: '#6b7280', fontSize: 12, marginTop: 2 }}>
            Marcas NCL 25 (Moda) · Últimos 2 meses · Valida Instagram automaticamente
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {!status.rodando ? (
            <button onClick={iniciar} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              ▶ Iniciar Pipeline
            </button>
          ) : (
            <button onClick={parar} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              ⏹ Parar
            </button>
          )}
          {resultados.length > 0 && !status.rodando && (
            <button onClick={limpar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '6px 14px', fontSize: 13, cursor: 'pointer' }}>
              🗑 Limpar
            </button>
          )}
        </div>
      </div>

      {/* Progresso */}
      {(status.rodando || status.processados > 0) && (
        <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: '12px 16px', marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 13 }}>
            <span style={{ fontWeight: 600, color: '#0a1628' }}>
              {status.rodando ? '⏳ Processando...' : '✅ Concluído'}
            </span>
            <span style={{ color: '#6b7280' }}>
              {status.processados} / {status.total} empresas · <span style={{ color: '#16a34a', fontWeight: 700 }}>{qtdQualif} qualificadas</span>
            </span>
          </div>
          <div style={{ background: '#f3f4f6', borderRadius: 4, height: 8, overflow: 'hidden' }}>
            <div style={{ background: status.rodando ? '#3b82f6' : '#16a34a', height: '100%', width: `${progresso}%`, transition: 'width 0.5s', borderRadius: 4 }} />
          </div>
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>
            {status.rodando && 'Aguardando entre consultas para não ser bloqueado. Pode deixar rodando em background.'}
            {!status.rodando && status.processados > 0 && `Tempo estimado por empresa: ~6s · Pipeline finalizado.`}
          </div>
        </div>
      )}

      {/* Sem dados ainda */}
      {!status.rodando && resultados.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 0', background: '#fff', border: '1px solid #c8d0da', borderRadius: 4 }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>🔍</div>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#374151' }}>Nenhum resultado ainda</div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 6 }}>Clique em "Iniciar Pipeline" para começar a busca</div>
        </div>
      )}

      {/* Resultados */}
      {resultados.length > 0 && (
        <>
          {/* Filtros */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 600 }}>Filtrar:</span>
            {[
              { key: 'todos', label: `Todos (${resultados.length})` },
              { key: 'qualificados', label: `✅ Qualificados (${qtdQualif})` },
              { key: 'nao_encontrados', label: `❌ Não encontrados (${resultados.filter(r => r.instagram_status === 'nao_encontrado').length})` },
            ].map(f => (
              <button key={f.key} onClick={() => setFiltro(f.key)}
                style={{ background: filtro === f.key ? '#0a1628' : '#f3f4f6', color: filtro === f.key ? '#fff' : '#374151', border: '1px solid #d1d5db', borderRadius: 12, padding: '3px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                {f.label}
              </button>
            ))}
          </div>

          {/* Tabela */}
          <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr>
                  {['Empresa', 'Marca', 'UF', 'Procurador', 'Instagram', 'Seguidores', 'Ação'].map(h => (
                    <th key={h} style={{ padding: '6px 10px', textAlign: 'left', background: '#0a1628', color: '#fff', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map((r, i) => (
                  <tr key={r._id} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '7px 10px', fontWeight: 600, color: '#0a1628', maxWidth: 200 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.titular || '—'}</div>
                    </td>
                    <td style={{ padding: '7px 10px', color: '#374151', maxWidth: 140 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.nome_marca || <span style={{ color: '#9ca3af' }}>—</span>}</div>
                    </td>
                    <td style={{ padding: '7px 10px', color: '#6b7280' }}>{r.uf || '—'}</td>
                    <td style={{ padding: '7px 10px', color: r.procurador ? '#374151' : '#9ca3af', maxWidth: 140 }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.procurador || 'Sem representação'}</div>
                    </td>
                    <td style={{ padding: '7px 10px' }}>
                      {r.instagram_url ? (
                        <a href={r.instagram_url} target="_blank" rel="noreferrer"
                          style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: 600 }}>
                          @{r.instagram_usuario}
                        </a>
                      ) : <span style={{ color: '#d1d5db' }}>—</span>}
                    </td>
                    <td style={{ padding: '7px 10px' }}>
                      <StatusBadge status={r.instagram_status} seguidores={r.instagram_seguidores} />
                    </td>
                    <td style={{ padding: '7px 10px' }}>
                      {r.instagram_status === 'qualificado' && !r.adicionado_crm && (
                        <button onClick={() => adicionarCRM(r._id)} disabled={adicionando[r._id]}
                          style={{ background: adicionando[r._id] ? '#d1d5db' : '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                          {adicionando[r._id] ? '...' : '+ CRM'}
                        </button>
                      )}
                      {r.adicionado_crm && (
                        <span style={{ color: '#16a34a', fontSize: 11, fontWeight: 700 }}>✅ No CRM</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
